import css from '@styled-system/css'
import * as React from 'react'
import styled, { StyledComponent, ThemeContext } from 'styled-components'
import {
  color,
  ColorProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system'

const SvgIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    size?: number | string
    color?: string
  },
) => {
  const { size } = props

  if (size != null) {
    props = {
      width: size,
      height: size,
      ...props,
    }
  }

  const themeContext = React.useContext(ThemeContext)

  if (props.color != null) {
    props = { ...props, color: themeContext.colors[props.color] || props.color }
  }

  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M62.923 45.695h-7.166v7.138h-4.358v-7.138h-7.166v-4.358h7.166V34.2h4.358v7.138h7.166v4.358zM80.267 2.179v66.306a2.178 2.178 0 01-2.179 2.178H59.111v13.158A2.178 2.178 0 0156.932 86H7.912a2.178 2.178 0 01-2.179-2.179V17.515c0-1.204.975-2.178 2.179-2.178h18.977V2.179C26.89.975 27.864 0 29.068 0h48.991c1.233 0 2.208.975 2.208 2.179zM54.753 70.663H29.097a2.178 2.178 0 01-2.179-2.178V19.694H10.091v61.949h44.662v-10.98zM75.91 18.09H64.3a2.178 2.178 0 01-2.178-2.179V4.357H31.275v61.949H75.91V18.089zm0-13.732h-9.431v9.346h9.431V4.357z"
        fill={props.color || '#000'}
      />
    </svg>
  )
}

type StyledSystemProps = TypographyProps &
  SpaceProps &
  LayoutProps &
  ColorProps &
  PositionProps

const _style = (
  component: React.FC,
): StyledComponent<
  React.FC<
    React.SVGProps<SVGSVGElement> & {
      size?: number | string
      color?: string
    }
  >,
  Record<string, unknown>,
  StyledSystemProps,
  never
> => {
  const styledSystemProps = [typography, space, layout, color, position]
  return styled(component)(css({}), styledSystemProps)
}

const SvgFileAdd = _style(SvgIcon)

export default SvgFileAdd
